/**
 * @file App.tsx
 * @description Main application routing for TableGreet Digital TV Signage Engine.
 */

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SignagePage } from './pages/SignagePage';
import { LaunchPage } from './pages/LaunchPage';

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LaunchPage />} />
        <Route path="/pair" element={<LaunchPage />} />
        <Route path="/signage" element={<SignagePage />} />
        <Route path="/:venueSlug/signage" element={<SignagePage />} />
        <Route path="/:venueSlug" element={<SignagePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};
